import { ConversationId } from 'types/conversation'
import { createAction } from 'utils/redux'

export const clearActiveConversation = () => createAction({
  type: 'CLEAR_ACTIVE_CONVERSATION'
})

export const setActiveConversation = payload => createAction({
  type: 'SET_ACTIVE_CONVERSATION',
  payload
})

export const sendMessage = payload => createAction({
  type: 'SEND_MESSAGE',
  payload
})

export const setHasForcedConversation = () => createAction({
  type: 'SET_HAS_FORCED_CONVERSATION'
})

export const receiveMessageSent = payload => createAction({
  type: 'RECEIVE_MESSAGE_SENT',
  payload
})

export const receiveMessageSendFailure = payload => createAction({
  type: 'RECEIVE_MESSAGE_SEND_FAILURE',
  payload
})

export const receivePreRenderedMessages = payload => createAction({
  type: 'RECEIVE_PRE_RENDERED_MESSAGES',
  payload
})

export const receiveAgentMessage = payload => createAction({
  type: 'RECEIVE_AGENT_MESSAGE',
  payload
})

export const receiveAttachments = payload => createAction({
  type: 'RECEIVE_ATTACHMENTS',
  payload
})

export const setIsTyping = payload => createAction({
  type: 'RECEIVE_IS_TYPING',
  payload
})

export const receiveConversation = payload => createAction({
  type: 'RECEIVE_CONVERSATION',
  payload
})

export const receiveInitialActiveConversation = payload => createAction({
  type: 'RECEIVE_INITIAL_ACTIVE_CONVERSATION',
  payload
})

export const receiveMessagesForConversation = payload => createAction({
  type: 'RECEIVE_MESSAGES_FOR_CONVERSATION',
  payload
})

export const receiveBulkConversations = payload => createAction({
  type: 'RECEIVE_BULK_CONVERSATIONS',
  payload
})

export const receiveReadMessages = payload => createAction({
  type: 'RECEIVE_READ_MESSAGES',
  payload
})

export const setActiveDriftlink = payload => createAction({
  type: 'SET_ACTIVE_DRIFTLINK',
  payload
})

export const receiveAgentStatus = payload => createAction({
  type: 'RECEIVE_AGENT_STATUS',
  payload
})

export const setUnreadMessage = payload => createAction({
  type: 'SET_UNREAD_MESSAGE',
  payload
})

export const permacloseConversation = (payload: { conversationId: number }) => createAction({
  type: 'PERMACLOSE_CONVERSATION',
  payload
})

export const receiveCampaignConversations = payload => createAction({
  type: 'RECEIVE_CAMPAIGN_CONVERSATIONS',
  payload
})

export const setIgnoredConversation = (payload: ConversationId[] | ConversationId) => createAction({
  type: 'SET_IGNORED_CONVERSATION',
  payload
})
